<template>
  <a-modal :footer="null" :body-style="{maxHeight:'78vh',overflow:'auto'}" :title="`客服详情 · ${agent ? (agent.real_name || agent.nickname) : ''}`" width="94vw" :visible="visible" @cancel="$emit('close')">
    <a-tabs v-model="tab" @change="changeTab">
      <a-tab-pane key="summary" tab="销售统计" />
      <a-tab-pane key="orders" tab="历史订单" />
      <a-tab-pane key="logs" tab="操作日志" />
    </a-tabs>
    <a-form layout="inline" class="bar">
      <template v-if="tab === 'summary' || tab === 'orders'">
        <a-form-item label="时间范围">
          <a-select v-model="period" style="width:100px"><a-select-option value="all">全部</a-select-option><a-select-option value="year">年</a-select-option><a-select-option value="month">月</a-select-option></a-select>
        </a-form-item>
        <a-form-item v-if="period !== 'all'" label="年份"><a-input-number v-model="year" :min="1970" :max="2100" /></a-form-item>
        <a-form-item v-if="period === 'month'" label="月份"><a-select v-model="month" style="width:90px"><a-select-option v-for="n in 12" :key="n" :value="n">{{ n }}月</a-select-option></a-select></a-form-item>
        <a-form-item v-if="tab === 'orders'" label="订单号"><a-input v-model="keyword" allow-clear /></a-form-item>
      </template>
      <a-form-item v-if="tab === 'complaints'" label="状态"><a-select v-model="complaintStatus" allow-clear style="width:120px"><a-select-option :value="0">待处理</a-select-option><a-select-option :value="1">处理中</a-select-option><a-select-option :value="2">已处理</a-select-option></a-select></a-form-item>
      <a-form-item><a-button type="primary" @click="search">查询</a-button></a-form-item>
      <a-form-item v-if="tab === 'complaints'"><a-button v-hasPermi="['dkmall:customer-service-agent:edit']" @click="openComplaint()">登记投诉</a-button></a-form-item>
    </a-form>
    <template v-if="tab === 'summary'">
      <a-alert class="bar" type="info" show-icon message="确认收货后计入销售，不受是否评价影响；按确认收货时间统计，缺失时使用付款或下单时间。不同币种分别统计，净销售额为实收扣除退款。" />
      <a-table
        row-key="currency"
        :loading="loading"
        :data-source="salesRows"
        :columns="salesColumns"
        :pagination="false"
        bordered />
      <a-statistic class="bar" title="服务评价数量（全部时间）" :value="(summary.ratings || []).reduce((n,r)=>n+Number(r.rating_count||0),0)" suffix="条" />
      <p class="note">订单客服归属在创建时固定，客户迁移不改变历史业绩。旧订单按升级时现有业务员或责任客服补齐；未分配客服的订单不计入个人业绩。</p>
    </template>
    <template v-else>
      <a-alert v-if="tab === 'orders'" class="bar" type="info" message="历史订单包含各状态正式订单，按下单时间筛选；询盘单独管理。" />
      <a-alert v-if="tab === 'ratings'" class="bar" type="info" message="读取客户在商城提交的满意度、问题解决情况和评价内容。评价不影响销售统计。" />
      <a-table
        :row-key="rowKey"
        :loading="loading"
        :data-source="rows"
        :columns="columns"
        :pagination="pagination"
        bordered
        @change="pageChange">
        <template slot="customer" slot-scope="t,r">{{ r.real_name || r.nickname || '-' }}<div class="note">ID {{ r.user_id || r.user_id_2 || r.customer_id }}</div></template>
        <template slot="money" slot-scope="t,r">{{ r.currency }} {{ money(r.paid) }}<div class="note">退款 {{ money(r.refunded) }}；净额 {{ money(r.net_amount) }}</div></template>
        <template slot="status" slot-scope="t,r">{{ orderStatus(r.status) }}</template>
        <template slot="time" slot-scope="t,r">{{ datetime(r.create_time) }}</template>
        <template slot="complaintStatus" slot-scope="t,r"><a-tag :color="Number(r.status) === 2 ? 'green' : 'orange'">{{ ['待处理','处理中','已处理'][Number(r.status)] }}</a-tag></template>
        <template slot="orderOp" slot-scope="t,r"><a @click="viewOrder(r)">查看订单</a></template>
        <template slot="complaintOp" slot-scope="t,r"><a v-if="Number(r.status) !== 2" v-hasPermi="['dkmall:customer-service-agent:edit']" @click="openProcess(r)">处理</a><a-divider type="vertical" /><a @click="showComplaintLogs(r)">处理记录</a></template>
      </a-table>
    </template>
    <a-modal :title="processing ? '处理投诉' : '登记投诉'" :visible="complaintVisible" :confirm-loading="saving" @ok="saveComplaint" @cancel="complaintVisible=false">
      <a-form-model :model="complaintForm" :label-col="{span:5}" :wrapper-col="{span:18}">
        <template v-if="!processing">
          <a-form-model-item label="客户ID" required><a-input-number v-model="complaintForm.customerId" :min="1" style="width:100%" /></a-form-model-item>
          <a-form-model-item label="订单号"><a-input v-model="complaintForm.orderSn" placeholder="可选，填写后会核对客服和客户归属" maxlength="100" /></a-form-model-item>
          <a-form-model-item label="联系方式"><a-input v-model="complaintForm.contact" maxlength="150" /></a-form-model-item>
          <a-form-model-item label="投诉内容" required><a-textarea v-model="complaintForm.content" :rows="4" maxlength="2000" /></a-form-model-item>
        </template>
        <template v-else>
          <p>{{ complaintForm.content }}</p>
          <a-form-model-item label="处理状态"><a-radio-group v-model="complaintForm.status"><a-radio :value="1">处理中</a-radio><a-radio :value="2">已处理</a-radio></a-radio-group></a-form-model-item>
          <a-form-model-item label="处理意见" required><a-textarea v-model="complaintForm.result" :rows="4" maxlength="2000" /></a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>
    <a-modal title="投诉处理记录" :visible="logVisible" :footer="null" width="800px" @cancel="logVisible=false">
      <a-table row-key="id" :data-source="complaintLogs" :columns="complaintLogColumns" :pagination="false" />
    </a-modal>
  </a-modal>
</template>
<script>
import { performanceSummary, performanceRows, addServiceComplaint, processServiceComplaint, serviceComplaintLogs } from '@/api/dkmall/customer-service'
export default {
  name: 'ServicePerformanceDrawer',
  props: { visible: Boolean, agent: { type: Object, default: null }, initialTab: {type:String,default:'summary'} },
  data() {
    return {
      tab: 'summary',
period: 'all',
year: new Date().getFullYear(),
month: new Date().getMonth() + 1,
      keyword: '',
complaintStatus: undefined,
loading: false,
requestVersion: 0,
      summary: {},
rows: [],
total: 0,
pageNum: 1,
pageSize: 20,
      complaintVisible: false,
complaintForm: {},
processing: false,
saving: false,
      logVisible: false,
complaintLogs: [],
      ratingSummaryColumns: [{ title: '满意度', dataIndex: 'satisfaction_level' }, { title: '问题解决', dataIndex: 'problem_solving' }, { title: '评价数量', dataIndex: 'rating_count' }],
      salesColumns: [{ title: '币种', dataIndex: 'currency' }, { title: '完成订单数', dataIndex: 'order_count' }, { title: '实收金额', dataIndex: 'paid' }, { title: '退款金额', dataIndex: 'refunded' }, { title: '净销售额', dataIndex: 'net_amount' }],
      complaintLogColumns: [{ title: '时间', dataIndex: 'create_time' }, { title: '状态', dataIndex: 'status', customRender: v => ['待处理', '处理中', '已处理'][Number(v)] }, { title: '处理意见', dataIndex: 'result' }, { title: '操作人ID', dataIndex: 'operator_id' }]
    }
  },
  computed: {
    salesRows() { return (Number(this.agent && this.agent.csc)===1 ? ['CNY'] : ['CNY', 'USD']).map(currency => ({ currency, order_count: 0, paid: 0, refunded: 0, net_amount: 0, ...(this.summary.sales || []).find(x => x.currency === currency) })) },
    ratingSummary() { return (this.summary.ratings || []).map((row, i) => ({ ...row, key: i })) },
    pagination() { return { current: this.pageNum, pageSize: this.pageSize, total: this.total, showSizeChanger: true, showTotal: n => `共 ${n} 条` } },
    columns() {
      const customer = { title: '客户', scopedSlots: { customRender: 'customer' } }
      const time = { title: '时间', scopedSlots: { customRender: 'time' } }
      if (this.tab === 'orders') return [{ title: '订单号', dataIndex: 'order_sn',width:180 }, customer, {title:'客户手机',dataIndex:'buyer_mobile',width:140},{title:'订单类型',dataIndex:'order_type',customRender:v=>({3:'现货订单',12:'定制采购订单',13:'设计订单',14:'样品订单',15:'自定义订单',16:'补差价订单'})[v]||v,width:130},{ title: '商品（中文 / 英文）', dataIndex: 'goods_names',width:300 },{title:'应付金额',dataIndex:'payable_money',width:120}, { title: '实收 / 退款 / 净额', scopedSlots: { customRender: 'money' },width:190 }, { title: '状态', scopedSlots: { customRender: 'status' },width:120 }, time,{title:'付款时间',dataIndex:'pay_time',customRender:v=>this.datetime(v),width:180}, { title: '操作', scopedSlots: { customRender: 'orderOp' },width:120 }]
      if (this.tab === 'ratings') return [customer, { title: '满意度', dataIndex: 'satisfaction_level' }, { title: '问题解决', dataIndex: 'problem_solving' }, { title: '评价内容', dataIndex: 'content' }, time]
      if (this.tab === 'complaints') return [customer, { title: '订单号', dataIndex: 'order_sn' }, { title: '投诉内容', dataIndex: 'content' }, { title: '处理意见', dataIndex: 'process_result' }, { title: '状态', scopedSlots: { customRender: 'complaintStatus' } }, time, { title: '操作', scopedSlots: { customRender: 'complaintOp' } }]
      return [{ title: '类别', dataIndex: 'category' }, { title: '操作', dataIndex: 'action' }, { title: '详情', dataIndex: 'remark' }, { title: '操作人ID', dataIndex: 'operator_id' }, time]
    }
  },
  watch: {
    visible(value) { if (value) { this.tab = ['ratings','complaints'].includes(this.initialTab)?this.initialTab:'summary'; this.period = 'all'; this.pageNum = 1; this.summary = {}; this.load() } else { this.requestVersion++; this.complaintVisible = false; this.logVisible = false } },
    'agent.id'() { if (this.visible) { this.pageNum = 1; this.summary = {}; this.load() } }
  },
  methods: {
    viewOrder(row) { this.$emit('close'); this.$router.push({path:'/dkmall/dkmall-order/order-list',query:{orderSn:row.order_sn}}) },
    load() {
      if (!this.agent) return Promise.resolve()
      const version = ++this.requestVersion
      const params = { period: this.period, year: this.year, month: this.month, keyword: this.keyword, status: this.complaintStatus, pageNum: this.pageNum, pageSize: this.pageSize }
      this.loading = true; this.rows = []
      const request = this.tab === 'summary' ? performanceSummary(this.agent.id, params) : performanceRows(this.agent.id, this.tab, params)
      return request.then(r => {
        if (version !== this.requestVersion) return
        if (this.tab === 'summary') this.summary = r.data || {}
        else { this.rows = (r.data && r.data.rows) || []; this.total = Number((r.data && r.data.total) || 0) }
      }).finally(() => { if (version === this.requestVersion) this.loading = false })
    },
    complaintCount(status) { const row = (this.summary.complaints || []).find(x => Number(x.status) === status); return row ? row.complaint_count : 0 },
    search() { this.pageNum = 1; this.load() },
    rowKey(row) { return this.tab === 'complaints' ? row.id : this.tab === 'logs' ? row.category + '-' + row.aid : row.aid },
    changeTab() { this.pageNum = 1; this.load() },
    pageChange(p) { this.pageNum = p.current; this.pageSize = p.pageSize; this.load() },
    money(v) { return Number(v || 0).toFixed(2) },
    datetime(v) { if (!v) return '-'; return /^\d+$/.test(String(v)) ? new Date(Number(v) * 1000).toLocaleString() : v },
    orderStatus(v) { return ({ '-7': '设计/生产中', '-6': '待付款', '-5': '询盘', '-1': '已取消', 0: '待付款', 1: '待发货', 2: '已发货', 3: '已签收', 4: '已完成', 7: '待付款', 8: '准备发货', 9: '设计中', 10: '生产中', 11: '生产完成' })[Number(v)] || `状态 ${v}` },
    openComplaint(order) { this.processing = false; this.complaintForm = { customerId: order ? Number(order.user_id) : undefined, orderSn: order ? order.order_sn : '', content: '', contact: '' }; this.complaintVisible = true },
    openProcess(row) { this.processing = true; this.complaintForm = { id: row.id, content: row.content, status: 1, result: '' }; this.complaintVisible = true },
    saveComplaint() {
      if (this.processing ? !String(this.complaintForm.result || '').trim() : (!this.complaintForm.customerId || !String(this.complaintForm.content || '').trim())) return this.$message.warning('请填写必填信息')
      this.saving = true
      const id = this.agent.id
      const request = this.processing ? processServiceComplaint(id, this.complaintForm.id, this.complaintForm) : addServiceComplaint(id, this.complaintForm)
      return request.then(() => { this.$message.success('保存成功'); this.complaintVisible = false; if (this.agent.id === id) this.load() }).finally(() => { this.saving = false })
    },
    showComplaintLogs(row) { serviceComplaintLogs(this.agent.id, row.id).then(r => { this.complaintLogs = r.data || []; this.logVisible = true }) }
  }
}
</script>
<style scoped>
.bar { margin-bottom: 16px }
.note { color: #888; font-size: 12px; margin-top: 8px }
</style>
